import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import {AuthProvider} from './app/modules/auth'
import AppRoutes1, {AppRoutes} from './app/routing/AppRoutes'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {ToastContainer} from 'react-toastify'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {refetchOnWindowFocus: false, cacheTime: Infinity, networkMode: 'always'},
  },
})
const App = ({client}: {client?: any}) => {
  return (
    <>
      <QueryClientProvider client={client || queryClient}>
        <MetronicI18nProvider>
          <AuthProvider>{client ? <AppRoutes1 /> : <AppRoutes />}</AuthProvider>
        </MetronicI18nProvider>
        {!client && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
      {!client && (
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      )}
    </>
  )
}
export default App
